const BASE = process.env.REACT_APP_APIURL || 'http://localhost:4000/';
const api = (path) => `${BASE.replace(/\/$/, '')}/${path}`;

export class UsuarioModuloApi {
  async checkUsuarioModuloExists(id_usuario, id_modulo) {
    const res = await fetch(api(`usuariomodulo/${id_usuario}/${id_modulo}`));
    if (!res.ok) throw new Error(`checkUsuarioModuloExists: ${res.status}`);
    return res.json(); // { exists: 0 | 1 }
  }

  async InsertUserAprobado(data) {
    const res = await fetch(api('usuariomodulo'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error(`InsertUserAprobado: ${res.status}`);
    return res.json();
  }

  async deleteUsuarioModulo(id_usuario, id_modulo) {
    const res = await fetch(api(`usuariomodulo/${id_usuario}/${id_modulo}`), { method: 'DELETE' });
    if (!res.ok) throw new Error(`deleteUsuarioModulo: ${res.status}`);
    return { success: true };
  }
}
